export default {
    namespaced: true,
    state: {
        isOfficesModalOpen: false,
        notificationModal: {
            isOpen: false,
            type: null,
            message: null
        },
    },
    mutations: {
        TOGGLE_OFFICES_MODAL(state, payload) {
            state.isOfficesModalOpen = payload;
        },
        OPEN_NOTIFICATION_MODAL(state, payload) {
            state.notificationModal.isOpen = true;
            state.notificationModal.type = payload.type;
            state.notificationModal.message = payload.message;
        },
        CLOSE_NOTIFICATION_MODAL(state) {
            state.notificationModal.isOpen = false;
        }
    },
    actions: {
        async toggleOfficesModal({commit}, payload) {
            commit('TOGGLE_OFFICES_MODAL', payload)
        },
        async openNotificationModal({commit}, payload) {
            commit('OPEN_NOTIFICATION_MODAL', payload)
        },
        async closeNotificationModal({commit}) {
            commit('CLOSE_NOTIFICATION_MODAL')
        },
    }
};
